// extracted by mini-css-extract-plugin
export default {"Header":"header_Header__e0GpT","nav_items":"header_nav_items__c4ZXK"};